/**
 * 这里保存内嵌云班webview的外壳环境信息
 * 【要注意的是】
 *  1.仅用于web环境
 *  2.若要判断是否为小程序代码，请使用process.env.isMiniprogram
 */
 import Filter from '@helpers/Filter';

 export enum EWebviewEnv { // 运行webview的环境
   app = 'app',
   miniprogram = 'miniprogram',
   web = 'web'
 }

 export enum EProjectCode { // 内嵌该页面的项目
   none = 'none', // 正常web展示
   seewoCube = 'seewo-cube' // 希沃魔方
 }

 const urlParams = Filter.getUrlParams(['webviewEnv', 'projectcode'])
 export const webviewEnv: EWebviewEnv = urlParams.webviewEnv ? urlParams.webviewEnv.toLowerCase() as EWebviewEnv : EWebviewEnv.web
 export const projectCode = urlParams.projectcode ? urlParams.projectcode as EProjectCode : EProjectCode.none

//希沃魔方app
export const isCubeApp = () => webviewEnv === EWebviewEnv.app && projectCode === EProjectCode.seewoCube

//是否为app内嵌webview
export const isWebInApp = () => webviewEnv === EWebviewEnv.app;